// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Jq6q","footer":"ModalCreateQualiphyProcedure_footer__25cOj","additionData":"ModalCreateQualiphyProcedure_additionData__32o0A"};